import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useHistory, useLocation } from "react-router-dom";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { ValTextAndNumber } from "../../../Validators/ValTextAndNumber";
import { InputAdornment, MenuItem, TextField } from "@mui/material";
import { GetDocumentpo } from "../../../Helpers/GetDocumento";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { TextFieldCliente } from "./TextFieldCliente";
import { ValidarDatosFactura } from "./ValidaDatosFactura";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export const CargarDatosFacturaScreen = () => {
  const history = useHistory();
  const { state } = useLocation();

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [datos_pedido, setDatos_pedido] = useState({});
  const [financiamiento, setFinanciamiento] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [datos_facturacion, setDatosFacturacion] = useState({
    comentarios: "",
    comentarioscredito: "",
    estado: "",
    tiempoestimado: "",
    tiempotranscurrido: "",
    factura: false,
    nota_abono: false,
    idequip: "",
    idsucursal: "",
    serie_fiscal: "",
    folio_fiscal: "",
    documento: "",
  });
  const [sucursales_cliente, setSucursales_cliente] = useState([]);
  const [selected, setselected] = useState(null);
  const [factura, setFactura] = useState({
    documento: "",
    extension: "",
  });
  const [notaabono, setNotaAbono] = useState({
    documento: "",
    extension: "",
  });
  const [documentosequipo, setDocumentosEQUIP] = useState([]);
  const onChange = (prop, value, sbool, smensaje) => {
    // setComentarios(value);
  };
  const onDatosFacturacion = (prop, value, sbool, smensaje) => {
    setDatosFacturacion({
      ...datos_facturacion,
      [prop]: value,
    });
  };

  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerFactura?folio=${
          state.folio
        }&registro=${selected.registro}&iddocumento=${Number(iddocumento)}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const onGuardar = () => {
    var data = datos_facturacion;
    const validate = ValidarDatosFactura(
      data,
      factura,
      notaabono,
      state.folio,
      datos_pedido.financiera,
      datos_facturacion.factura,
      datos_facturacion.nota_abono,
      selected.registro
    );

    const documento = datos_facturacion.documento;
    var updatedFinanciamiento = "";

  // Verificar si documento tiene un valor válido
  if (documento) {
    // Actualizar el valor de documento en cada elemento de financiamiento
    updatedFinanciamiento = financiamiento.map(element => {
      return {
        ...element,
        documento: documento
      };
    });

    // Actualizar el estado de financiamiento con los nuevos valores de documento
    setFinanciamiento(updatedFinanciamiento);
  }

    var mensaje = "";
    var valido = true;
    var documentosfinanciamiento = [];
    updatedFinanciamiento.forEach((element) => {
      if (
        element.documento === undefined ||
        element.documento === null ||
        element.documento === ""
      ) {
        mensaje =
          mensaje +
          "Pendiente de relacionar el numero de documento en equip para el registro con importe de <bold>" +
          FormatMoney(element.totalpagar) +
          "</bold><br/><br/>";
        valido = false;
      } else {
        documentosfinanciamiento = [
          ...documentosfinanciamiento,
          {
            docto: element.docto,
            documento: element.documento,
          },
        ];
      }
    });
    if (valido === false) {
      Swal.fire("FACTURACION", mensaje, "error");
      return;
    }
    if (validate.isValid === false) {
      Swal.fire("FACTURACION", validate.mensaje, "error");
      return;
    }
    validate.post.documentos = documentosfinanciamiento;
    setLoader({ ...loader, mostrar: true });
    request
      .post("ACJDF_Cargar_Factura", validate.post)
      .then(async () => {
        setLoader({ ...loader, mostrar: false });
                setDatosFacturacion([]);
        await Swal.fire(
          "FACTURACION",
          "Factura Registrada con exito",
          "success"
        );
        history.push("/Credito/listadoequiposfacturar");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FacturarEquipo/informacion_pedido?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDatos_pedido(result.datos_pedido);
        setFinanciamiento(result.financiamiento);
        setUnidades(result.unidades);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  }, []);
  const onActualizarArray = (value, element) => {
    var newarray = financiamiento.map((item) => {
      if (item.docto === element.docto) {
        item.documento = value;
      }
      return item;
    });
    setFinanciamiento(newarray);
  };

  const onBuscarFactura = (item) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `FacturarEquipo/informacion_pedido_unidad?folio=${
          state.folio
        }&registro=${Number(item.registro)}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDatosFacturacion(result.datos_pedido);
        setSucursales_cliente(result.sucursales);
        setselected(item);
        setDocumentosEQUIP(result.documentos);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };
  const [updatedocumento, setupdatedocumento] = useState(null);
  const updateDocumento = (index, value) => {
    var newvalue = documentosequipo;
    newvalue[index].documento = value;
    newvalue = [...newvalue, { orden: 0, documento: "" }];
    setDocumentosEQUIP(newvalue);
    setupdatedocumento(!(updatedocumento === null ? true : updatedocumento));
  };

  useEffect(() => {
    if (updatedocumento !== null) {
      const registros = documentosequipo.length;
      setDocumentosEQUIP(
        documentosequipo.filter((aa, index) => index !== registros - 1)
      );
    }
  }, [updatedocumento]);

  const onEliminarDocumento = (orden, index) => {
    if (orden !== 0) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `FacturarEquipo/EliminarRegistro?folio=${state.folio}&orden=${Number(
            orden
          )}&registro=${Number(selected.registro)}`
        )
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Facturación de Equipo", "Registro eliminado", "success");
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("FACTURACION", JSON.stringify(error), "error");
        });
    }
    setDocumentosEQUIP(
      documentosequipo.filter((e, position) => position !== index)
    );
  };

  return (
    <PlantillaScreen
      titulo={`FACTURAR CREDITO DE ${state.cliente}`}
      className={"listado-tasa-intereses-main-screen"}
      className_main={1}
    >
      <div className="solicitud-credito-a-facturar">
        <LoaderScreen loader={loader} />
        <div className="solicitud-credito-datos-pedido">
          <TextField
            label="Razón Social"
            value={datos_pedido.razonsocial}
            size="small"
            color="success"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="RFC"
            value={datos_pedido.rfc}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Método de Pago"
            value={datos_pedido.metodopago}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Forma de Pago"
            value={datos_pedido.formapago}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Uso de CFDI"
            value={datos_pedido.usocfdi}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Tipo de Relación"
            value={datos_pedido.tiporel}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Anticipos"
            value={datos_pedido.anticipos}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Folios de Anticipos"
            value={datos_pedido.foliosanticipos}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="solicitud-credito-info-facturar">
          <div className="header">
            Datos de Factura
            </div>
          {/* Tabla para representar los equipos solicitados*/}
          <div className="container-table-unidades">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Línea</th>
                  <th>Modelo</th>
                  <th>Importe</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {unidades.map((item) => (
                  <tr>
                    <td>{item.linea}</td>
                    <td>{item.modelo}</td>
                    <td>{FormatMoney(item.importe)}</td>
                    <td>
                      <ReceiptLongIcon onClick={() => onBuscarFactura(item)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Tabla de los detalles del financiamiento*/}
          <div className="container-table-financiamiento">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Vencimiento</th>
                  <th>Importe</th>
                  <th>Interes</th>
                  <th>Total Pagar</th>
                </tr>
              </thead>
              <tbody>
                {financiamiento.map((item) => (
                  <tr>
                    <td>{item.vencimiento}</td>
                    <td>{FormatMoney(item.importefinanciar)}</td>
                    <td>{FormatMoney(item.interes)}</td>
                    <td>{FormatMoney(item.totalpagar)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/*FACTURAS */}
          {selected !== undefined && selected !== null && (
            <div className="solicitud-credito-factura">
              <div className="solicitud-credito-factura-header">
                {`${selected.modelo} (${FormatMoney(selected.importe)})`}
              </div>
              <TextField
                fullWidth
                size="small"
                label="Serie Fiscal"
                className="col1"
                type="text"
                onChange={({ target }) => {
                  ValTextAndNumber(
                    "serie_fiscal",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.serie_fiscal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="Folio Fiscal"
                className="col2"
                type="text"
                onChange={({ target }) => {
                  ValTextAndNumber(
                    "folio_fiscal",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.folio_fiscal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="Documento EQUIP"
                className="cel3"
                type="text"
                onChange={({ target }) => {
                  ValOnlyNumber(
                    "documento",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.documento}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextFieldCliente
                array={sucursales_cliente}
                onDatosFacturacion={onDatosFacturacion}
                idequip={datos_facturacion.idequip}
              />
              <TextField
                fullWidth
                size="small"
                label="Sucursal"
                className="col5"
                type="text"
                value={datos_facturacion.sucursal}
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <div className="col8">
                <div className="label-facturacion">Cargar Factura</div>
                <TextField
                  // label="Cargar Factura"
                  fullWidth
                  size="small"
                  type="file"
                  onChange={({ target }) => GetDocumentpo(target, setFactura)}
                />
                {datos_facturacion.factura === true && (
                  <CheckCircleIcon
                    className="has_document"
                    onClick={() =>
                      onImprimirArchivo(
                        datos_pedido.financiera === "JDF" ? 71 : 28
                      )
                    }
                  />
                )}
              </div>
              {datos_pedido.financiera === "JDF" && (
                <div className="col9">
                  <div className="label-facturacion">Cargar Nota de Abono</div>
                  <TextField
                    // label="Cargar Nota de abono"
                    fullWidth
                    size="small"
                    type="file"
                    onChange={({ target }) =>
                      GetDocumentpo(target, setNotaAbono)
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end"></InputAdornment>
                      ),
                    }}
                  />
                  {datos_facturacion.nota_abono === true && (
                    <CheckCircleIcon
                      className="has_document"
                      onClick={() => onImprimirArchivo(78)}
                    />
                  )}
                </div>
              )}
              <table
                className="solicitud-credito-detalle-factura"
                cellPadding={0}
                cellSpacing={0}
              >
                <thead>
                  <tr>
                    <th>Documentos</th>
                    <th>
                      <AddCircleIcon
                        onClick={() =>
                          setDocumentosEQUIP([
                            ...documentosequipo,
                            { orden: 0, documento: "" },
                          ])
                        }
                      ></AddCircleIcon>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {documentosequipo.map((item, index) => (
                    <tr>
                      <td colSpan={2}>
                        <DeleteForeverIcon
                          onClick={() => onEliminarDocumento(item.orden, index)}
                        ></DeleteForeverIcon>

                        <input
                          id={`ìnput-${index}`}
                          value={item.documento}
                          onChange={({ target }) =>
                            updateDocumento(index, target.value)
                          }
                        ></input>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <div className="solicitud-credito-footer">
        <div
          className="solicitud-credito-footer-regresar"
          onClick={() => {
            history.push(
              "/Credito/listadoequiposfacturar"
            );
          }}
        >
          <ArrowBackIcon />
          Regresar
        </div>
        <div
          className="solicitud-credito-footer-guardar"
          onClick={() => {
            onGuardar();
          }}
        >
          <CheckCircleIcon />
          <div>Registrar</div>
        </div>
      </div>
    </PlantillaScreen>
  );
};
